import '@fontsource/source-sans-pro/300.css'
import '@fontsource/source-sans-pro/400.css'
import '@fontsource/source-sans-pro/600.css'
import '@fontsource/source-sans-pro/700.css'
import '@fontsource/source-sans-pro/900.css'
import '@fontsource/source-code-pro'

import { createGlobalStyle } from 'styled-components'

import { ButtonTheme } from './styles/ButtonTheme'
import { Theming } from './styles/Theming'

import '../styles/reset.css'
import { Prose } from './styles/Prose'

export const GlobalStyles = createGlobalStyle`
  :root {
    background-color: ${({ theme }) => theme.colors.white[1]};
    color: ${({ theme }) => theme.colors.black[1]};
    font-family: 'Source Sans Pro', sans-serif;
    overflow-x: hidden;
    overflow-y: auto;
    
    // anti-aliasing
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    font-size: 21px;

    scroll-behavior: smooth;
    
    @media (max-width: 1600px) {
      font-size: 20px;
    }
    
    @media (max-width: 992px) {
      font-size: 19px;
    }
    
    @media (max-width: 480px) {
      font-size: 18px;
    }
  }

  ${Theming}
  ${ButtonTheme}
  ${Prose}
  
  html {
    scroll-padding-top: 6rem;
    
    @media screen and (max-width: 1080px) {
      scroll-padding-top: 4.5rem;
    }
  }
  
  body {
    font-size: 1rem;
  }

  ::-webkit-scrollbar {
      width: 0.3rem;
      background: ${p => p.theme.colors.black[6]};
      border-radius: 0.25rem;
    }

  ::-webkit-scrollbar-thumb {
    background: ${p => p.theme.colors.black[4]};
    width: 0.15rem;
    border-radius: 0.25rem;

    &:hover {
      background: ${p => p.theme.colors.black[3]};
    }

    &:active {
      background: ${p => p.theme.colors.black[2]};
    }
  }
`
